import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../CssFiles/About.css";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
// import Profile from "../images/Profile/my.png";
import Profile from "../images/Profile/my_pic.jpg";

const About = () => {
  return (
    <div className="about" id="about">
      <h1 className="pt-3 text-center font-details pb-3">ABOUT ME</h1>
      <Container>
        <Row className="pt-3 pb-5 align-items-center">
          <Col xs={12} md={6}>
            <Row className="justify-content-center mb-2 mr-2 ">
              <Image
                className="profile justify-content-end"
                alt="profile"
                src={Profile}
                thumbnail
                fluid
              />
            </Row>
          </Col>
          <Col xs={12} md={6} className="my-details">
            <Row className=" align-items-start p-2 rounded details-row">
              <p>
              Greetings! I'm <strong>&nbsp;Paras Pandey</strong>, a dedicated programmer hailing from India, with a fervent passion for technology and innovation. As Software Engineer at <strong>Nagarro</strong>,
               I leverage my background in Computer Science, having completed my Engineering degree in 2022, to deliver exceptional quality and service to every project I undertake.
              </p>
              <p>
              My professional ethos revolves around consistently exceeding expectations and ensuring an unparalleled user experience.
               I am committed to crafting cutting-edge, scalable solutions that address real-world challenges through the application of emerging technologies.
              </p>
              <p>
              Driven by an insatiable curiosity, I thrive on staying abreast of the latest advancements in the tech realm.
               Understanding the core problems that new technologies solve fuels my drive to integrate them effectively, thereby elevating the quality and functionality of the products I develop.
              </p>
              <p>
              I am impassioned by the pursuit of knowledge and constantly seek opportunities for growth, embracing every chance to refine my skills and broaden my technological expertise.
               My ultimate goal is to contribute meaningfully to the evolution of innovative and impactful products that resonate with users on a global scale.
              </p>
              <p>
              Let's connect and collaborate on building transformative solutions that push the boundaries of what technology can achieve.
              </p>
            </Row>
            <Row className=" d-flex justify-content-center flex-wrap p-2 details-row">
              <div className="talk">
                <a href="#contact">
                  <Button className="m-2" variant="outline-primary">
                    Let's Talk
                  </Button>
                </a>
              </div>
              <div className="resume">
                <a
                  href="https://drive.google.com/file/d/1ernDZnnqBUR3qlv2CaXeu91EfUS5BDtR/view?usp=drive_link"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Button className="m-2" variant="outline-success">
                    My Resume
                  </Button>
                </a>
              </div>
              <div className="github">
                <a
                  href="https://github.com/ParasPandey"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Button className="m-2" variant="outline-dark">
                    Github
                  </Button>
                </a>
              </div>
              <div className="linkedin">
                <a
                  href="https://www.linkedin.com/in/paras-pandey-b938b3183/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Button className="m-2" variant="outline-info">
                    Linkedin
                  </Button>
                </a>
              </div>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About;
